import React, { useContext, useEffect } from 'react'
import FilterMethods from './Home/FilterMethods'
import JobWorkSpace from './Home/JobWorkSpace'
import CommonContext from 'hooks/CommonContext'

const Dashboard = () => {
  const {
    setIsSmallDevice
  } = useContext(CommonContext);

  useEffect(() => {
    if (window.innerWidth <= 992) {
      setIsSmallDevice(true)
    } else {
      setIsSmallDevice(false)
    }
  }, [window.innerWidth])

  return (
    <div className='placeholder-glow'>
      <section className='homePage-backgroundColor'>
        <FilterMethods />
        <JobWorkSpace />
      </section>
    </div>
  )
}

export default Dashboard